import React from "react";
import { Platform } from "react-native";
import WebTimePicker from "./WebTimePicker";
import NativeTimePicker from "./NativeTimePicker";

const TimePicker: React.FC<TimePickerT> = (props) => {
  return Platform.OS === "web" ? (
    <WebTimePicker {...props} />
  ) : (
    <NativeTimePicker {...props} />
  );
};

export default TimePicker;
